// @flow
import api from 'tim-api';
import { listAccessReport, exportAccessReport } from 'endPoints';

export const state: Object = {
  ids: [],
  users: [],
  AccessReportList: [],
  isSearchersCleared: false
};

export const getters = {
  ids: (state: Object) => state.ids,
  users: (state: Object) => state.users,
  usersFilter: (state: Object) => state.usersFilter,
  AccessReportList: (state: Object) => state.AccessReportList,
  isSearchersCleared: (state: Object) => state.isSearchersCleared,
};

export const mutations = {
  SET_IDS_FILTER(state: Object, idsFilter: Array) {
    state.idsFilter = idsFilter;
  },
  SET_USERS_FILTER(state: Object, usersFilter: Array) {
    state.usersFilter = usersFilter;
  },
  SET_USERS(state: Object, users: Array<Object>) {
    state.users = users;
  },
  SET_EXPORT(state: Object, data: Array<Object>) {
    state.data = data;
  },
  SET_REPORT_LIST(state: Object, data: Array<Object>) {
    state.AccessReportList = data;
  },
  SET_IS_SEARCHERS_CLEARED(state: Object, isSearchersCleared: Boolean) {
    state.isSearchersCleared = isSearchersCleared;
  }
};

export const actions = {
  fetchUsers({ commit }: Action, { filterOptions }: Object) {
    let url = 'tracking/users';
    if (filterOptions.name) {
      url += `/${filterOptions.name}?field_filter=name`;
    }
    if (filterOptions.registration) {
      url += `/${filterOptions.registration}?field_filter=registration`;
    }
    return api.get(url)
      .then(({ data }) => {
        commit('SET_USERS', data.data.data);
      });
  },

  fetchExportAccess({ commit }: Action, filter: Object) {
    let url = `${exportAccessReport}?`;
    
    if (filter.initial_date) {
      url = `${url}&initial_date=${filter.initial_date}&final_date=${filter.final_date}`;
    }
    if (filter.registration) {
      url = `${url}&registrations=${filter.registration}`;
    }
    
    return api.get(`${url}`);
  },

  fetchAccessReportList({ commit }: Action, { DTO }: Object) {
    let url = `${listAccessReport}?`;

    if (DTO) {
      if (DTO.page) {
        url = `${url}&page=${DTO.page}`;
      }
      if (DTO.date_start) {
        url = `${url}&initial_date=${DTO.date_start}&final_date=${DTO.date_end}`;
      }
      if (DTO.registration) {
        url = `${url}&registrations=${DTO.registration}`;
      }
    }

    return api.get(`${url}`).then(({ data }) => {
      if (data.data.content.data.length > 0) {
        commit('SET_REPORT_LIST', data.data.content);
      } else {
        commit('SET_REPORT_LIST', undefined);
      }
    }).catch(() => {
      commit('SET_REPORT_LIST', undefined);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
